// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Trigger: stacked icon cluster, floats over the card's top-right corner ── */
.rbc-trigger {
  position: absolute;
  top: -9px;
  right: -9px;
  display: flex;
  align-items: center;
}

.rbc-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/RequestBadgeCluster/RequestBadgeCluster.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;AACpB","sourcesContent":["/* ── Trigger: stacked icon cluster, floats over the card's top-right corner ── */\n.rbc-trigger {\n  position: absolute;\n  top: -9px;\n  right: -9px;\n  display: flex;\n  align-items: center;\n}\n\n.rbc-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  border: 2px solid #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
